<template lang="pug">
  .page
    .text-center
    section
      .text-center
        b-container
          h1 RENTING ART
          p
            | Although we believe in harnessing the
            | benefits of a digital and interconnected
            | world, we recognise that sometimes
            | it’s hard to replace something tangible
            | and real. This is especially true for art.
            | As a response to this challenge, we’ve
            | developed an offering that aims to ensure
            | that true interaction remains a part of the
            | online collector’s experience
          b-button.btn-outline(:to="{ name: 'gallery'}") BROWSE GALLERY
    section
      b-container
        .row
          .col-md-4.text-center.py-3
            img.inst-tile(src="@/assets/images/illustrations/rentals1.svg")
            p.mt-2 1. FIND THE PERFECT PIECE TO RENT
          .col-md-4.text-center.py-3
            img.inst-tile(src="@/assets/images/illustrations/rentals2.svg")
            p.mt-2 2. GET IT DELIVERED TO YOUR DOOR
          .col-md-4.text-center.py-3
            img.inst-tile(src="@/assets/images/illustrations/rentals3.svg")
            p.mt-2 3. EXPERIENCE IT IN YOUR SPACE
        .row.my-5.bg-alt
          .col-12.text-center.p-3
            h4.m-0 AFTER RENTAL PERIOD
        .row
          .col-md-4.text-center.py-3
            img.inst-tile(src="@/assets/images/illustrations/rentals4.svg")
            p.mt-2 RETURN IN OUR REUSABLE PACKAGING
          .col-md-4.center-xy
            div
              h4 OR
              hr
          .col-md-4.text-center.py-3
            img.inst-tile(src="@/assets/images/illustrations/rentals5.svg")
            p.mt-2 PURCHASE TO KEEP
    section.bg-alt.text-center
      b-container
        h1 WHY RENT ART?
        br
        h7.font-weight-bold Buy with peace of mind
        p.text-dark
          | It gives you the chance to test the piece
          | in your own space, before committing to
          | the purchase
        h7.font-weight-bold Increased accessibility
        p.text-dark
          | We believe everyone has much to gain from being
          | exposed to thoughtful artwork,and that this experience
          | shouldn’t only be reserved for those with the means
          | to buy priceless art.
        h7.font-weight-bold Increased appeal
        p.text-dark
          | Renting better suits the dynamic needs of a wide and
          | diverse audience, including commercial, residential
          | or hospitality requirements.
        h7.font-weight-bold It's more flexible
        p.text-dark
         | If you enjoy variety or prefer rotating a selection
         | of works for whatever reason, rentals are the
         | perfect solution.
    section.text-center
      b-container
        h4 Browse our rental FAQs
        .row
          .col-0.col-md-3
          .col-6.col-md-3.px-1
            b-button.btn-outline.btn-block(:to="{ name: 'help', query: { audience: 'customer', topic: 'rentals'} }") FOR COLLECTORS
          .col-6.col-md-3.px-1
            b-button.btn-outline.btn-block(:to="{ name: 'help', query: { audience: 'artist', topic: 'rentals'} }") FOR ARTISTS
    section.section-dark
      b-container.text-center
        h1 FALLEN IN LOVE?
        p We'll refund 75% of your total rental spend towards purchasing a piece you are renting.
        b-button.btn-outline-light(:to="{ name: 'gallery'}") BROWSE GALLERY
</template>

<script>
export default {
  name: 'Rentals',
  metaInfo() {
    return { title: 'Wall Collective fine art rental' };
  },
};
</script>

<style lang="scss" scoped>
  .inst-tile {
    height: 100px;
  }
</style>



// WEBPACK FOOTER //
// src/components/views/Rentals.vue